import { Validator } from '@vista-digital/validator';
import { defaultMemberBarcodeConfig, memberBarcodeConfigValidator } from './config';
export const defaultMemberBarcodeProps = {
    config: defaultMemberBarcodeConfig
};
export const memberBarcodePropsValidator = Validator.object({
    config: memberBarcodeConfigValidator
});
